import React from 'react';
import type { BriefWorkout } from '../../services/api';
import { CalendarWorkoutCard } from '../calendar/CalendarWorkoutCard';
import {workoutRowText} from './workoutRowText';
import {useTranslation} from 'react-i18next';

interface Props {
  workout: BriefWorkout;
  onPress: () => void;
}

export function MobileWorkoutRow({ workout, onPress }: Props) {
  const {i18n} = useTranslation();
  const {sport, title, metrics} = workoutRowText(workout, i18n.resolvedLanguage ?? i18n.language);

  return (
    <CalendarWorkoutCard
      workout={workout}
      display={{sport, title, metrics}}
      onPress={onPress}
    />
  );
}
